import { Button } from '@avanta/shared/components/ui/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@avanta/shared/components/ui/DropdownMenu';
import { CHAT_BUTTON_CLASSNAME } from '@avanta/shared/constants/chat';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import {
  useActiveConversation,
  useConversationsStore,
} from '@avanta/shared/stores/chat/conversations';
import { cn } from '@avanta/shared/utils/cn';
import { CircleX, EllipsisVertical } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const Header = (): React.ReactElement => {
  const isOtherUserOnline = useConversationsStore(state => state.isOtherUserOnline);
  const setActiveChannel = useConversationsStore(state => state.setActiveChannel);
  const activeConversation = useActiveConversation();
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  const handleOnClose = (): void => {
    setActiveChannel(null);
    navigate(-1);
  };

  return (
    <div className="flex justify-between items-center p-4 border-b border-plum-200 bg-white sticky top-0 left-0 right-0 z-10">
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-medium md:text-base">{activeConversation?.otherUser.name}</p>
        {isOtherUserOnline ? (
          <div className="flex items-center gap-2 animate-in fade-in-0 duration-300">
            <span className="size-2 rounded-full bg-teal-500" />
            <span className="text-xs text-gray-500">{t('Chat.Header.online')}</span>
          </div>
        ) : null}
      </div>
      <div className="flex items-center gap-1">
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              icon="only"
              className={cn(CHAT_BUTTON_CLASSNAME, 'hover:[&>svg]:stroke-2')}
            >
              <EllipsisVertical className="size-5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="bottom" align="end">
            <DropdownMenuItem className="hover:bg-gray-100" onClick={handleOnClose}>
              <CircleX />
              {t('Chat.close')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
